/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_GrayInputs */

const en_booking_color_gray = /** @type {(inputs: Booking_Color_GrayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gray`)
};

const pl_booking_color_gray = /** @type {(inputs: Booking_Color_GrayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szary`)
};

/**
* | output |
* | --- |
* | "Gray" |
*
* @param {Booking_Color_GrayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_gray = /** @type {((inputs?: Booking_Color_GrayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_GrayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_gray(inputs)
	return en_booking_color_gray(inputs)
});